import React, { Fragment, useRef } from 'react';

const NavigationItem = ({ links = [], contentLink = null }) => {
    const menuRef = useRef(null);
    const toggleMenu = () => {
        menuRef.current.classList.toggle('navbar__menu--show');
    };
    const additionClass =
        contentLink && contentLink.attributes
            ? contentLink.attributes.cssValue
            : null;
    const selectedClass =
        contentLink && contentLink.isSelected ? 'navbar__link--selected' : '';
    const hasChildrenClass = links.length > 0 ? 'has-children' : null;
    const hasNameOrChildren = (link) =>
        link.name || (link.links || []).length > 0;

    return (
        <Fragment>
            {contentLink && (
                <Fragment>
                    <a
                        className={`navbar__link ${selectedClass} ${
                            hasChildrenClass || ''
                        } ${additionClass || ''}`}
                        href={contentLink.url || '#'}
                        dangerouslySetInnerHTML={{ __html: contentLink.name }}
                    ></a>
                </Fragment>
            )}

            {links.length > 0 && (
                <ul className="navbar__menu" ref={menuRef}>
                    <div className="navbar__menu-header">
                        {contentLink && (
                            <Fragment>
                                <span
                                    className="navbar__title"
                                    onClick={toggleMenu}
                                    dangerouslySetInnerHTML={{
                                        __html: contentLink.name,
                                    }}
                                ></span>
                            </Fragment>
                        )}
                    </div>
                    {links.length > 0 &&
                        links.map(
                            (link, i) =>
                                hasNameOrChildren(link) && (
                                    <li className="navbar__item" key={link.url}>
                                        <NavigationItem
                                            links={link.links}
                                            contentLink={link}
                                        />
                                    </li>
                                )
                        )}
                </ul>
            )}
        </Fragment>
    );
};

export default NavigationItem;
